import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Popup, Position, ToolbarItem} from "devextreme-react/popup";
import Form, {GroupItem, Label, SimpleItem, ButtonItem, FormRef} from "devextreme-react/form";
import {Button, DateBox, NumberBox, TextBox} from "devextreme-react";
import {Item as TabItem} from "devextreme-react/tab-panel";
import {useContextPopupPage} from "../../components/popups/PopupPage";
import FormListBaseTab from '../base/form-list-base-tab';
import useCustomDataSource from '../../hooks/useCustomDataSource';
import IFermetureModule from '../../models/IFermetureModule';
import {FormListBase} from '../base';

interface IPopupFermeturesModulesProps {
    isPopupOpen: boolean,
    onClose: () => void
    // onReserver: (ajoutReservationOption: IAjoutReservationOption) => void
}

function PopupFermeturesModules({isPopupOpen, onClose}: IPopupFermeturesModulesProps) {
    const fermetureModuleFormDataSource = useCustomDataSource<IFermetureModule, IFermetureModule>({path: "fermeturemodule", primaryKey: "idFermetureModule"});
    const {setMainForm, selectedDataRow: selectedJournal, isFieldModifier, setIsFieldModifier, onFieldDataChanged} = fermetureModuleFormDataSource;
    const [isOpen, setPopupIsOpen] = useState(true);
    const {selectedValue, setSelectedValue} = useContextPopupPage();
    const formRef = useRef<FormRef>(null);

    const closeButtonOption = useMemo(() => {
        return {
            text: "Annuler",
            onClick: () => setPopupIsOpen(false)
        }
    }, [])
    const reserverButtonOption = useMemo(() => {
        return {
            text: "Appliquer",
            onClick: () => {
                onClose()
            }
        }
    }, [onClose])

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    useEffect(() => {
        if (setSelectedValue && selectedJournal?.idFermetureModule) {
            setSelectedValue(selectedJournal?.idFermetureModule)
        }
    }, [selectedJournal]);

    if (!isOpen) return null;
    return (
        <Popup title={"Fermetures de modules"} dragEnabled={false} visible={isOpen} onHiding={onClose} width={400}
               height={400}
        >
            <Position my="center" collision="fit"/>
            <FormListBase key={"frm-messages"} data={fermetureModuleFormDataSource} hideList={true} hideToolbar={true}>
                <FormListBaseTab className='no-nav-button'>
                    <TabItem>
                        <Form
                            ref={formRef}
                            readOnly={false} alignItemLabelsInAllGroups={true}
                            formData={selectedJournal || {} as IFermetureModule}
                            className={"forms"} labelLocation={"left"} showColonAfterLabel={true}
                            onFieldDataChanged={onFieldDataChanged}
                        >
                            <GroupItem>
                                <SimpleItem key={"frm-achat"} dataField={"dateTransaction"} editorType={"dxDateBox"}>
                                    <Label text={"Achat"}/>
                                </SimpleItem>
                                <SimpleItem key={"frm-facturation"} dataField={"dateTransaction"} editorType={"dxDateBox"}>
                                    <Label text={"Facturation"}/>
                                </SimpleItem>
                                <SimpleItem key={"frm-paiement"} dataField={"dateTransaction"} editorType={"dxDateBox"}>
                                    <Label text={"Paiement"}/>
                                </SimpleItem>
                                <SimpleItem key={"frm-encaissement"} dataField={"dateTransaction"} editorType={"dxDateBox"}>
                                    <Label text={"Encaissement"}/>
                                </SimpleItem>
                                <SimpleItem key={"frm-journal-general"} dataField={"dateTransaction"} editorType={"dxDateBox"}>
                                    <Label text={"Journal Général"}/>
                                </SimpleItem>
                                <SimpleItem key={"frm-debourses"} dataField={"dateTransaction"} editorType={"dxDateBox"}>
                                    <Label text={"Déboursés"}/>
                                </SimpleItem>
                            </GroupItem>
                        </Form>
                    </TabItem>
                </FormListBaseTab>
            </FormListBase>

            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="before"
                options={reserverButtonOption}
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={closeButtonOption}
            />
        </Popup>
    )
        ;
}

export default PopupFermeturesModules;